import { IOfferCard } from '../../../../types';
import { preparePhotos } from './preparePhotos';
import { prepareThumbnails } from './prepareThumbnails';

export const prepareGallery = (offerCard: IOfferCard) => ({
  photos: preparePhotos(offerCard),
  thumbnails: prepareThumbnails(offerCard),
  badges: offerCard.photoFeatureIcons,
});
